import type { ReactNode } from 'react';

export enum ToastSentiment {
  /** Use negative sentiment for errors or failures. */
  Negative = 'negative',
  /** Use neutral sentiment for warning. */
  Neutral = 'neutral',
  /** Use positive sentiment for success messages. */
  Positive = 'positive',
}

/** Represent a toast object that should be displayed as an alert. */
export interface ToastObj {
  /**
   * The variant of the sentiment of the message.
   *
   * @defaultValue ToastSentiment.Positive
   */
  sentiment?: ToastSentiment;
  /** The message to show in the toast. */
  message?: ReactNode | string;
}

/** Add the toast to the {@link ToastContext} and opens it. */
export type ToastDispatcher = (
  toast: ToastObj,
  options?: Omit<ToastOptions, 'isOpen'>
) => void;

export interface ToastOptions {
  /** Whether the toast should be open. */
  isOpen?: boolean;
  /** Callback after when the toast is closed. */
  onClose?: () => void;
  /** Display a button to close the toast. Will turn off the auto-close feature. */
  buttonLabel?: string;
  /**
   * The timeout before closing the toast.
   *
   * @defaultValue {@link ToastConstant.Timeout}
   */
  timeout?: number;
  /**
   * Whether toast should close after the timeout.
   *
   * @defaultValue `false` when a `buttonLabel` is provided. `true` otherwise.
   */
  autoClose?: boolean;
}
